import { render, staticRenderFns } from "./CreatePaymentAdditionalFields.vue?vue&type=template&id=2a2261d6&scoped=true"
import script from "./CreatePaymentAdditionalFields.vue?vue&type=script&lang=js"
export * from "./CreatePaymentAdditionalFields.vue?vue&type=script&lang=js"
import style0 from "./CreatePaymentAdditionalFields.vue?vue&type=style&index=0&id=2a2261d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2261d6",
  null
  
)

export default component.exports